export default {
  getHead: () => {
    return [{ name: "회사명" }, { name: "편성액" }, { name: "지출잔액" },  { name: "작성일" }];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).stdInfo.field_name; // 회사명
      case 1:
        return func.getContent(value).totalBudget.편성액; // 편성액
      case 2:
        return func.getContent(value).totalBudget.지출잔액; // 지출잔액
      case 3:
        return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    switch (nav.value.searchType) {
    case "회사명":
      returnData.push("content$body.stdInfo.field_name*%[:default_skw]%");
      break;
    case "소속2":
      returnData.push("content$body.stdInfo.department*%[:default_skw]%");
      break;
    case "소속1":
      returnData.push("content$body.stdInfo.com_name*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};
